import { ProjectArrays } from '~/constants';
import { Project, ProjectArray, ProjectArrayAmounts, ProjectArrayCounts } from '~/types/project';


export default function calculateProjectArrayTotals(project: Project): {
  projectArrayAmounts: ProjectArrayAmounts,
  arrayCounts: ProjectArrayCounts
} {
  // Create structure based on mount types
  const projectArrayAmounts = [...Object.keys(ProjectArrays), 'TOTAL'].reduce((acc, key: string) => {
    acc[key] = {
      sizeKwdc: 0,
      sizeKwac: 0,
      production: 0,
      productionFactor: 0,
    };
    return acc;
  }, {} as ProjectArrayAmounts);

  let arrayCounts: ProjectArrayCounts = {
    ROOFTOP: 0,
    GROUNDMOUNT_FIXED_TILT: 0,
    GROUNDMOUNT_SINGLE_AXIS: 0,
    CARPORT_CANOPY: 0,
  };
  
  // Add up the totals
  project.projectArrays?.forEach((projectArray: ProjectArray) => {
    const type = projectArray.type as keyof ProjectArrayCounts;
    if (!type) {
      // Filter out any project arrays without a type
      return;
    }
    if (type && arrayCounts[type] !== undefined) {
      arrayCounts[type]++;
    } 

    const sizeKwdc = projectArray.sizeKwdc ?? 0;
    const sizeKwac = projectArray.sizeKwac ?? 0;
    let production: number;
    if (projectArray?.yearOneProductionUnit === 'KWH') {
      production = projectArray.yearOneProduction ?? 0;
    } else  {
      // unit is KWH_KW
      production = sizeKwdc && projectArray?.yearOneProduction ? projectArray?.yearOneProduction * sizeKwdc : 0;
    }
    projectArrayAmounts[type].sizeKwdc += sizeKwdc;
    projectArrayAmounts[type].sizeKwac += sizeKwac;
    projectArrayAmounts[type].production += production;

    projectArrayAmounts.TOTAL.sizeKwdc += sizeKwdc;
    projectArrayAmounts.TOTAL.sizeKwac += sizeKwac;
    projectArrayAmounts.TOTAL.production += production;
  });

  for (const key of Object.keys(projectArrayAmounts)) {      
    const row = projectArrayAmounts[key];
    if (row.sizeKwdc) {
      row.productionFactor = row.production / row.sizeKwdc;
    }
  }

  return { projectArrayAmounts, arrayCounts };
}